import { render, staticRenderFns } from "./ls-shop-change.vue?vue&type=template&id=10603eb2&scoped=true"
import script from "./ls-shop-change.vue?vue&type=script&lang=ts"
export * from "./ls-shop-change.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10603eb2",
  null
  
)

export default component.exports